<script lang="ts" setup>
import { shallowRef } from 'vue';
import { useFocusZone } from '../../composables';
import { injectStrict } from '../../utils';
import { OB_TABS_CONTEXT } from './shared';
const rootRef = shallowRef<HTMLDivElement | null>(null);
useFocusZone({
  container: rootRef,
  focusOutBehavior: 'wrap',
  bindKeys: ['ArrowLeft', 'ArrowRight'],
});
const { variant } = injectStrict(
  OB_TABS_CONTEXT,
  undefined,
  '<ObTabsList /> must be a child of <ObTabs /> component.',
);
</script>

<template>
  <div
    ref="rootRef"
    :class="variant === 'secondary' ? $style.secondary : $style.primary"
    role="tablist"
    aria-orientation="horizontal"
  >
    <slot />
  </div>
</template>

<style lang="scss" module>
@use '../../styles/shared';

.primary {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  height: 36px;
  min-height: 36px;
  border-bottom: 1px solid var(--ui2-stroke-secondary, #e4e5e8);
  overflow-x: auto;
}

.secondary {
  display: inline-flex;
  vertical-align: top;
}
</style>
